import { ContentService } from './ContentService';
import { ActiveLanguageId } from './Config/ActiveProfile';

export const getText = (key: string): string => {
  const languageDictionary = ContentService.GetLanguage(ActiveLanguageId);
  return languageDictionary[key] || 'N/A';
};

export const translate = (innerHTML: string): string => {
  const regex = /{{.*?}}/g;

  let replacement;
  const translationTemplates = innerHTML.match(regex) as RegExpMatchArray;

  translationTemplates.forEach((template) => {
    replacement = getText(template.replace('{{', '').replace('}}', ''));
    innerHTML = innerHTML.replace(template, replacement);
  });

  return innerHTML;
};
